import {
  required,
  requiredIf,
  minLength,
  email,
  sameAs
} from 'vuelidate/lib/validators'


export default {
  name: {
    required,
    minLength: minLength(3)
  },

  email: {
    required,
    email
  },

  password: {
    required: requiredIf('password'),
    minLength: minLength(3)
  },

  password_confirmation: {
    minLength: minLength(3),
    sameAsPassword: sameAs('password')
  }
}